import { forwardRef, type Ref, type SVGProps } from "react";
const IconMessageHeartOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 7.7a3.8 3.8 0 0 0-4.9.4 4 4 0 0 0 0 5.5l4 4a1.3 1.3 0 0 0 .9.4 1.5 1.5 0 0 0 1-.4l4-4a4 4 0 0 0 0-5.4 3.8 3.8 0 0 0-5-.5m4 3.2a1.9 1.9 0 0 1-.5 1.2L16 15.7l-3.5-3.5a1.9 1.9 0 0 1-.5-1.3 1.9 1.9 0 0 1 .5-1.3 1.8 1.8 0 0 1 1.3-.6 1.8 1.8 0 0 1 1.3.5l.9 1 1-1a1.8 1.8 0 0 1 2.5 0 1.9 1.9 0 0 1 .5 1.4"
    />
    <path
      fill="currentColor"
      d="M27 3H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h3v6a1 1 0 0 0 0 .4 1 1 0 0 0 .6.5 1 1 0 0 0 .8 0 1 1 0 0 0 .3-.2l6.7-6.7H27a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m1 3v13a1 1 0 0 1-1 1H16a1 1 0 0 0-.7.3L10 25.6V22c.3-1-1-2-2.1-2H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMessageHeartOutlineSVG);
ForwardRef.displayName = "IconMessageHeartOutline";
export { ForwardRef as IconMessageHeartOutline };
